module.exports = __webpack_public_path__ + "static/img/logo62.1d28aa8.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/login_logo_img/logo62.png
// module id = 1YU7
// module chunks = 1